import { useParams } from 'react-router'
import { PageErrorBoundary } from '@/components/error-boundaries/page-error-boundary'
import { WebhookPage } from '@/routes/webhook/page'

const Webhook = () => {
  const { idWebhook } = useParams()
  return (
    <PageErrorBoundary>
      <WebhookPage key={idWebhook} />
    </PageErrorBoundary>
  )
}

export default Webhook
